import Cookies from 'js-cookie';
import * as comUtils from "common/utils";
export * from "common/utils";
import * as constants from 'common/constants';


export function getCookie(name, attributes={}) {
  return Cookies.get(name, attributes);
}
